import React from 'react';
import SEOHead from '@/components/common/SEOHead';
import { SITE_URL } from '@/lib/constants/urls';

const IndexPageSEO = () => {
  const structuredData = [
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "@id": `${SITE_URL}#website`,
      "name": "PaperVerse",
      "url": `${SITE_URL}/`,
      "description": "An AI-assisted academic writing and peer-review platform for drafting in LaTeX, resolving citations, compiling PDFs, and improving research papers.",
      "potentialAction": {
        "@type": "SearchAction",
        "target": {
          "@type": "EntryPoint",
          "urlTemplate": `${SITE_URL}/explore?search={search_term_string}`
        },
        "query-input": "required name=search_term_string"
      }
    },
    {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "PaperVerse - AI Academic Writing and Peer Review",
      "description": "Write research papers with an AI co-author, real citations, LaTeX, and compiled PDFs, then receive structured review feedback before submission.",
      "url": `${SITE_URL}/`,
      "mainEntity": {
        "@type": "Service",
        "name": "Academic Writing and Peer Review Platform",
        "description": "AI-assisted LaTeX writing, citation grounding, PDF compiling, and structured paper review in one research workflow.",
        "provider": {
          "@type": "Organization",
          "name": "PaperVerse",
          "url": SITE_URL,
          "sameAs": [
            `${SITE_URL}/about`
          ]
        },
        "serviceType": "AI Academic Writing and Peer Review",
        "category": "Research Tools",
        "hasOfferCatalog": {
          "@type": "OfferCatalog",
          "name": "Research Writing and Review Services",
          "itemListElement": [
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "PaperVerse Writer",
                "description": "Draft and revise research papers in LaTeX with real citations and a compiled PDF."
              }
            },
            {
              "@type": "Offer", 
              "itemOffered": {
                "@type": "Service",
                "name": "Structured AI Paper Review",
                "description": "Receive structured feedback on methodology, clarity, novelty, and technical rigor."
              }
            }
          ]
        }
      },
      "breadcrumb": {
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": `${SITE_URL}/`
          }
        ]
      }
    },
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "PaperVerse", 
      "url": SITE_URL,
      "description": "Academic writing and peer-review software that helps researchers draft, ground, compile, review, and revise papers.",
      "foundingDate": "2024",
      "applicationCategory": "ResearchTool",
      "serviceArea": {
        "@type": "Place",
        "name": "Worldwide"
      },
      "audience": {
        "@type": "Audience",
        "audienceType": "Researchers, Academics, Scientists, Graduate Students"
      }
    }
  ];

  return (
    <SEOHead 
      title="PaperVerse | AI Academic Writing and Peer Review"
      description="Write research papers with an AI co-author using LaTeX, real citations, and compiled PDFs. Review and improve your manuscript before submission."
      canonicalUrl={`${SITE_URL}/`}
      keywords="AI academic writing, AI research assistant, LaTeX editor, research paper writer, citation assistant, PDF compiler, AI peer review, paper review tool, manuscript feedback, arXiv review"
      structuredData={structuredData}
    />
  );
};

export default IndexPageSEO;
